// @flow

import styled, { css } from 'styled-components';
import circleSvgSrc from './circle.svg';
import { theme } from '../../theme';

export const Separator = styled.div`
  ${({ direction = 'vertical', size = '0.2em' }) => direction === 'vertical' && css`
    width: 100%;
    height: ${size};
  `}

  ${({ direction = 'vertical', size = '0.2em' }) => direction === 'horizontal' && css`
    height: 100%;
    width: ${size};
  `}

  background-position-y: center;

  ${({ pattern }) => pattern === 'dotted' && css`
    background-repeat: repeat-x;
    background-image: url(${circleSvgSrc});
  `}

  ${({ pattern }) => pattern === 'solid' && css`
    background-color: ${theme.colors.gray(85)};
  `}
`;
